import { format } from 'date-fns';
import { getUserLanguage } from 'helpers/languageHelper';
import { formatNumberWithFractionDigits } from 'helpers/thousandFormatNumber';
import { capitalizeFirstLetter } from 'helpers/capitalizeFirstLetter';
import { defaultDateFnsLocale } from 'helpers/locale';
import { DayWaterOverviewInfo, WaterOverviewInfo } from 'providers/types/api-private';
import { t } from 'i18next';

export function formatNumber(number: number, space?: boolean): string {
  const language = getUserLanguage();

  const formattedNumber = formatNumberWithFractionDigits(number, {
    minimum: 0,
    maximum: 2,
  });

  const withSpace = space ? ' ' : '';

  return formattedNumber.replaceAll(language === 'pt-BR' ? '.' : ',', withSpace);
}

export function generateXAxisNames(data: WaterOverviewInfo): { value: string }[] {
  const axis: { value: string }[] = [];

  for (const item of (data.HISTORY ?? [])) {
    const day = isHistoryDayInfo(item) ? item.DAY : 1;
    const date = new Date(item.YEAR, item.MONTH - 1, day);
    axis.push({
      value: date.toISOString(),
    });
  }

  return axis;
}

function isHistoryDayInfo(history: WaterOverviewInfo['HISTORY'][number]): history is DayWaterOverviewInfo['HISTORY'][number] {
  return 'DAY' in history;
}

export function generateSubTitleByData(data: WaterOverviewInfo): string {
  const firstData = data.HISTORY[0];
  const firstDate = new Date(firstData.YEAR, firstData.MONTH - 1, 1);
  const firstLabel = formatDateSubTitle(firstDate);

  if (data.TYPE === 'day') {
    return t('consumoDeAguaMes', { month: firstLabel });
  }

  const lastData = data.HISTORY[data.HISTORY.length - 1];
  const lastDate = new Date(lastData.YEAR, lastData.MONTH - 1, 1);

  const lastLabel = formatDateSubTitle(lastDate);

  return t('consumoDeAguaDatas', {
    startDate: firstLabel,
    endDate: lastLabel,
  });
}

function formatDateSubTitle(date: Date): string {
  return capitalizeFirstLetter(format(date, "MMMM'/'yyyy", { locale: defaultDateFnsLocale }));
}
